import { ReactElement } from 'react'
import Input from '../../../components/Input'
import { MaterialWrapper } from './subcomponents'
import strings from '../../../locale/en'
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { setVideoChat, setVideoUrl } from '../../../redux/addMaterial/actions'
import { RootState } from '../../../redux/store'

const Video = (): ReactElement => {
  const {
    video: { url, chat }
  } = useSelector((state: RootState) => state.addMaterial, shallowEqual)
  const {
    menu: {
      material: { chatUrl, videoUrl }
    }
  } = strings
  const dispatch = useDispatch()

  return (
    <MaterialWrapper>
      <Input
        label={videoUrl}
        placeholder={''}
        value={url}
        name={videoUrl}
        onBlur={() => {}}
        onChange={(value) => {
          dispatch(setVideoUrl(value))
        }}
      />
      <Input
        label={chatUrl}
        placeholder={chatUrl}
        value={chat}
        name={chatUrl}
        onBlur={() => {}}
        onChange={(value) => {
          dispatch(setVideoChat(value))
        }}
      />
    </MaterialWrapper>
  )
}

export default Video
